// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"2cb3470a","654":"0b7d073f"}[chunkId] + ".chunk.css";
};